"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatReasoningFlow = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const common_1 = require("@/components/common");
require("@/components/common");
const toneIconMap = {
    thinking: common_1.ICON_NAMES.SPARKS,
    searching: common_1.ICON_NAMES.SEARCH,
    reading: common_1.ICON_NAMES.BOOK,
    writing: common_1.ICON_NAMES.DOCUMENT_CHECK,
};
/**
 * 현재 진행 중인 reasoning 흐름.
 *
 * <mm-chat-reasoning-flow tone="searching" label="관련 자료 탐색">
 *   디자인 토큰 문서를 찾는 중
 * </mm-chat-reasoning-flow>
 */
let ChatReasoningFlow = class ChatReasoningFlow extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.active = false;
        this.tone = 'thinking';
        this.label = '';
        this.description = '';
    }
    render() {
        return (0, lit_1.html) `
      <mm-icon name=${this.icon || toneIconMap[this.tone] || common_1.ICON_NAMES.SPARKS}></mm-icon>
      ${this.renderLabel()} ${this.renderDescription()}
      <mm-text size="12" color="light"><slot></slot></mm-text>
    `;
    }
    renderLabel() {
        if (!this.label)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-text size="14" weight="bold">${this.label}</mm-text>
    `;
    }
    renderDescription() {
        if (!this.description)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-text size="12" color="light">${this.description}</mm-text>
    `;
    }
};
ChatReasoningFlow.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: column;
      gap: var(--space-1);
    }

    :host([hidden]) {
      display: none;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, reflect: true })
], ChatReasoningFlow.prototype, "active", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ChatReasoningFlow.prototype, "tone", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ChatReasoningFlow.prototype, "label", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ChatReasoningFlow.prototype, "description", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ChatReasoningFlow.prototype, "icon", void 0);
ChatReasoningFlow = __decorate([
    (0, decorators_js_1.customElement)('mm-chat-reasoning-flow')
], ChatReasoningFlow);
exports.ChatReasoningFlow = ChatReasoningFlow;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hhdC1yZWFzb25pbmctZmxvdy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImNoYXQtcmVhc29uaW5nLWZsb3cudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQW9EO0FBQ3BELHFEQUEyRDtBQUUzRCxnREFBK0Q7QUFDL0QsK0JBQTRCO0FBSTVCLE1BQU0sV0FBVyxHQUE0QztJQUMzRCxRQUFRLEVBQUUsbUJBQVUsQ0FBQyxNQUFNO0lBQzNCLFNBQVMsRUFBRSxtQkFBVSxDQUFDLE1BQU07SUFDNUIsT0FBTyxFQUFFLG1CQUFVLENBQUMsSUFBSTtJQUN4QixPQUFPLEVBQUUsbUJBQVUsQ0FBQyxjQUFjO0NBQ25DLENBQUE7QUFFRDs7Ozs7O0dBTUc7QUFFSSxJQUFNLGlCQUFpQixHQUF2QixNQUFNLGlCQUFrQixTQUFRLGdCQUFVO0lBQTFDOztRQVl1QyxXQUFNLEdBQUcsS0FBSyxDQUFBO1FBQzlCLFNBQUksR0FBMEIsVUFBVSxDQUFBO1FBQ3hDLFVBQUssR0FBRyxFQUFFLENBQUE7UUFDVixnQkFBVyxHQUFHLEVBQUUsQ0FBQTtJQTBCOUMsQ0FBQztJQXZCQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTtzQkFDTyxJQUFJLENBQUMsSUFBSSxJQUFJLFdBQVcsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLElBQUksbUJBQVUsQ0FBQyxNQUFNO1FBQ3RFLElBQUksQ0FBQyxXQUFXLEVBQUUsSUFBSSxJQUFJLENBQUMsaUJBQWlCLEVBQUU7O0tBRWpELENBQUE7SUFDSCxDQUFDO0lBRU8sV0FBVztRQUNqQixJQUFJLENBQUMsSUFBSSxDQUFDLEtBQUs7WUFBRSxPQUFPLGFBQU8sQ0FBQTtRQUUvQixPQUFPLElBQUEsVUFBSSxFQUFBO3lDQUMwQixJQUFJLENBQUMsS0FBSztLQUM5QyxDQUFBO0lBQ0gsQ0FBQztJQUVPLGlCQUFpQjtRQUN2QixJQUFJLENBQUMsSUFBSSxDQUFDLFdBQVc7WUFBRSxPQUFPLGFBQU8sQ0FBQTtRQUVyQyxPQUFPLElBQUEsVUFBSSxFQUFBO3lDQUMwQixJQUFJLENBQUMsV0FBVztLQUNwRCxDQUFBO0lBQ0gsQ0FBQzs7QUF2Q00sd0JBQU0sR0FBRyxJQUFBLFNBQUcsRUFBQTs7Ozs7Ozs7OztHQVVsQixDQUFBO0FBQzJDO0lBQTNDLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxPQUFPLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDO2lEQUFlO0FBQzlCO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzsrQ0FBeUM7QUFDeEM7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO2dEQUFXO0FBQ1Y7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO3NEQUFpQjtBQUNoQjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7K0NBQWdCO0FBaEJoQyxpQkFBaUI7SUFEN0IsSUFBQSw2QkFBYSxFQUFDLHdCQUF3QixDQUFDO0dBQzNCLGlCQUFpQixDQXlDN0I7QUF6Q1ksOENBQWlCIn0=